import type React from 'react';

import { AmountSelector } from '../components/AmountSelector';
import { AverageAmountMessage } from '../components/AverageAmountMessage';
import { ContinueButton } from '../components/ContinueButton';
import { NewPaymentMethodPaypal } from '../components/NewPaymentMethodPaypal';
import { Selection } from '../components/Selection';
import type { ModalCallbackProps } from '../shared/types';

import { useMembershipForm } from './hooks/useMembershipForm';
import { useUserEventListeners } from './hooks/useUserEventListeners';

export const MembershipForm: React.FC<ModalCallbackProps> = ({ onAccept, onDecline }) => {
	const {
		actions: { onSelectNo, onSelectYes, onSubmit },
		data: {
			qaSuffix,
			copy: { yes, no },
			acceptMembership,
		},
	} = useMembershipForm({ onAccept, onDecline });

	useUserEventListeners({ onAccept, onDecline });

	return (
		<form onSubmit={onSubmit} className="mt-7">
			<div role="radiogroup" className="flex flex-col gap-4">
				<Selection
					qaSelectorSelection="ppmu-modal-selection-true"
					qaSelectorLabel={`ppmu-modal-selection-yes-title${qaSuffix}`}
					qaSelectorMessage={`ppmu-modal-selection-yes-description${qaSuffix}`}
					label={yes.label}
					message={yes.message}
					highlight={yes.highlight}
					checked={!!acceptMembership}
					onSelect={onSelectYes}
				>
					<AverageAmountMessage />
					<AmountSelector />
				</Selection>
				<Selection
					qaSelectorSelection="ppmu-modal-selection-false"
					qaSelectorLabel="ppmu-modal-selection-no-title"
					qaSelectorMessage={`ppmu-modal-selection-no-description${qaSuffix}`}
					label={no.label}
					message={no.message}
					checked={!acceptMembership}
					onSelect={onSelectNo}
				/>
				<div className="mt-3">
					<ContinueButton />
					<NewPaymentMethodPaypal onAccept={onAccept} onDecline={onDecline} />
				</div>
			</div>
		</form>
	);
};
